// Shared non-component exports; keep component modules valid Fast Refresh boundaries.
import { createContext, useContext } from "react";
import { type UserOut } from "./lib/api";

export type AuthState = {
  user: UserOut | null;
  // "Are we signed in?" — the real session lives in httpOnly cookies; this is
  // derived from whether GET /auth/me returned a user.
  isAuthenticated: boolean;
  // True while we probe /auth/me on first load, so the shell doesn't flash the
  // sign-in page (or vice-versa) before we know the session state.
  isHydrating: boolean;
  login: () => void;
  logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
